import { useNavigate } from 'react-router-dom';
import { SecurityGroupForm } from '../components/SecurityGroupForm';
import { useSecurityGroupMutations } from '../hooks/useSecurityGroupMutations';

export function SecurityGroupCreate() {
  const navigate = useNavigate();
  const { createMutation } = useSecurityGroupMutations();

  return (
    <section className="space-y-4">
      <h1 className="text-2xl font-semibold">New Security Group</h1>
      <SecurityGroupForm
        mode="create"
        onSubmit={(data) => createMutation.mutate(data, {
          onSuccess: (created) => navigate(`/admin/security-groups/${created.id}`),
        })}
        isLoading={createMutation.isPending}
        submitLabel="Create Group"
      />
    </section>
  );
}
